<template>
  <div class="container-fluid py-5">
    <div class="container-fluid">

      <div class="masonry-grid" v-if="!isFinalist">
        
        <div 
          v-for="(item, index) in items" 
          :key="index" 
          class="cat-image-wrapper shadow-sm"
        >
          <img 
            :src="item.image" 
            class="cat-img" 
            :alt="item.name || 'galéria kép'"
          >
          
          <div class="cat-hover-overlay">
            <div class="text-center p-3">
              <span class="hover-title">{{ item.field_1 }}</span>
              <span class="hover-sub">Gazdi: {{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
       <div v-if="isFinalist">
            <div  v-for="(item, index) in items" 
            :key="index" class="mx-auto text-center">
                <img 
                    :src="item.image" 
                    class="img-fluid winner-img"
                    :alt="item.name || 'galéria kép'"
                >
                <p style="color: #F8BBD6;">{{ item.name }}</p>
                <p class="text-white">200.000 Ft értékű Lidl ajándékutalvány <br>+ profi kisállatfotózás</p>

            </div>
       </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Csak a képek listáját várja: [{ url: '...', name: '...' }, ...]
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    isFinalist: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

/* MASONRY (MOZAIK) BEÁLLÍTÁSOK */
.masonry-grid {
  column-count: 4; // Alapértelmezett 4 oszlop
  column-gap: 15px;
  width: 100%;

  @media (max-width: 992px) {
    column-count: 2; // Tableten 2 oszlop
  }
  @media (max-width: 576px) {
    column-count: 1; // Mobilon 1 oszlop
  }
}

.winner-img {
    max-width:400px;
    border-radius:10px;
    border:3px solid white;

    @media (max-width: 992px) {
        max-width: 100%;
    }
}   

.cat-image-wrapper {
  display: inline-block; // Megakadályozza a kártyák kettétörését oszlopváltásnál
  width: 100%;
  margin-bottom: 15px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  border: 3px solid #fff; // Fehér keret a magenta háttér előtt
  position: relative;
  cursor: pointer;

  &:hover {
    .cat-img {
      transform: scale(1.08);
    }
    .cat-hover-overlay {
      opacity: 1;
    }
  }
}

.cat-img {
  width: 100%;
  height: auto; // Dinamikus magasság a mozaik hatáshoz
  max-height: 550px; // Ésszerű maximum magasság
  display: block;
  object-fit: cover;
  transition: transform 0.5s ease;
}

/* HOVER STÍLUSOK */
.cat-hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 5;
}

.hover-title {
  display: block;
  color: black;
  font-weight: 900;
  font-size: 1.1rem;
  text-transform: uppercase;
  margin: 0;
}

.hover-divider {
  width: 30px;
  height: 2px;
  background-color: black;
  margin: 10px auto;
}

.hover-sub {
  color: #555;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}
</style>